/**
 * Const with disabled spinner endpoints.
 * Add new endpoints to this array for hide spinner on that endpoint.
 */
export const DISABLED_SPINNER_ENDPOINTS = [
  new RegExp(/^\/call\/info$/),
  new RegExp(/^\/patient\/ping$/),
  new RegExp(/^\/call$/),
  new RegExp(/^\/call\/([^/]+)\/uploadFile$/),
  new RegExp(/^\/call\/([^/]+)\/timeout$/),
  new RegExp(/^\/call\/([^/]+)\/validate$/),
  new RegExp(/^\/appointment\/([^/]+)\/available$/),
  new RegExp(/^\/medicalExamResult$/),
  new RegExp(/^\/waitingPatient\/status$/),
  new RegExp(/^\/call\/([^/]+)\/status$/),
  new RegExp(/^\/call\/([^/]+)\/coordinates$/),
  new RegExp(/^\/amplitude\/track$/),
  new RegExp(/^\/amplitude\/provider$/),
  new RegExp(/^\/affiliate\/([^/]+)\/checkService$/),
  new RegExp(/^\/call\/patient\/canMakeSessionCall$/),
];
